'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactKeyHandler = require('react-key-handler');

var _reactKeyHandler2 = _interopRequireDefault(_reactKeyHandler);

var _windowScrollBlocker = require('../../libs/windowScrollBlocker');

var _windowScrollBlocker2 = _interopRequireDefault(_windowScrollBlocker);

var _Portal = require('../Portal/Portal');

var _Portal2 = _interopRequireDefault(_Portal);

var _Container = require('./components/Container.FilePreview');

var _Container2 = _interopRequireDefault(_Container);

var _Card = require('./components/Card.FilePreview');

var _Card2 = _interopRequireDefault(_Card);

var _Header = require('./components/Header.FilePreview');

var _Header2 = _interopRequireDefault(_Header);

var _FileContainer = require('./components/FileContainer.FilePreview');

var _FileContainer2 = _interopRequireDefault(_FileContainer);

var _IFrame = require('./components/IFrame.FilePreview');

var _IFrame2 = _interopRequireDefault(_IFrame);

var _Image = require('./components/Image.FilePreview');

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Libs
// Components


var FilePreview = function (_Component) {
  _inherits(FilePreview, _Component);

  function FilePreview() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilePreview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePreview.__proto__ || Object.getPrototypeOf(FilePreview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selected: null
    }, _this.freeScroll = null, _this.initSelected = function () {
      var files = _this.props.files;
      if (!files.length) return;

      _this.setState({
        selected: _extends({}, files[0])
      });
    }, _this.select = function (file) {
      var _this$props = _this.props,
          files = _this$props.files,
          visible = _this$props.visible;
      if (!visible || !files.length || !files.find(function (_ref2) {
        var id = _ref2.id;
        return file.id === id;
      })) return;

      _this.setState({
        selected: _extends({}, file)
      });
    }, _this.onClose = function () {
      var _this$props2 = _this.props,
          visible = _this$props2.visible,
          onClose = _this$props2.onClose;
      if (!visible) return;
      onClose();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilePreview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleWindow(false, this.props.visible);
      if (this.props.visible) this.initSelected();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.handleWindow(prevProps.visible, this.props.visible);
      if (!prevProps.visible && this.props.visible) this.initSelected();else if (prevProps.visible && !this.props.visible) this.setState({
        selected: null
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleWindow(true, false);
    }
  }, {
    key: 'handleWindow',
    value: function handleWindow(previousShow, currentShow) {
      if (!previousShow && currentShow) {
        this.freeScroll = _windowScrollBlocker2.default.add();
      } else if (previousShow && !currentShow && this.freeScroll) {
        this.freeScroll();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          files = _props.files,
          visible = _props.visible;
      var selected = this.state.selected;
      return _react2.default.createElement(_Portal2.default, {
        always: true
      }, _react2.default.createElement(_Container2.default, {
        visible: visible
      }, visible && _react2.default.createElement(_reactKeyHandler2.default, {
        keyEventName: 'keydown',
        keyValue: 'Escape',
        onKeyHandle: this.onClose
      }), _react2.default.createElement(_Card2.default, {
        visible: visible
      }, _react2.default.createElement(_Header2.default, {
        files: files,
        selected: selected,
        onSelect: this.select,
        onClose: this.onClose
      }), selected === null ? null : _react2.default.createElement(_FileContainer2.default, {
        download: selected.url
      }, selected.file_format === 'image' ? _react2.default.createElement(_Image2.default, {
        src: selected.url
      }) : _react2.default.createElement(_IFrame2.default, {
        src: selected.url
      })))));
    }
  }]);

  return FilePreview;
}(_react.Component);

FilePreview.propTypes = {
  files: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    name: _propTypes2.default.string.isRequired,
    file_format: _propTypes2.default.string,
    url: _propTypes2.default.string.isRequired
  })),
  visible: _propTypes2.default.bool,
  onClose: _propTypes2.default.func
};
exports.default = FilePreview;